import EFVideoModal from '@/components/UI/EFVideoModal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

const A: React.FC = () => {
    const { locale = 'jp' } = useRouter();
    const { t } = useLang('d3u');
    const [isM, setIsM] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsM(window.innerWidth <= 1024);
        }
    }, []);

    const [visible, setVisible] = useState(false);
    const [youtube, setYoutube] = useState<string>('');
    const youtubeMap = {
        jp: 'https://www.youtube.com/embed/kiF9lAeQ9pM?si=7kviUtstcdPTvGXK',
    };

    const handlePlayYoutube = () => {
        setVisible(true);
        setYoutube(youtubeMap[locale] || youtubeMap.jp);

        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('A_title'),
            position: 'Product Detail_1',
        });
    };

    return (
        <section className={`${css.section} D3U-A GtmModuleData-section`} id="D3U-A" data-section-id={'D3U-A'} data-section-id2={t('A_title')}>
            <div className="img">
                <picture>
                    <img
                        fetchpriority="high"
                        src={
                            isM
                                ? 'https://websiteoss.ecoflow.com/upload/image/1763454004565/Frame%201000008651.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1763454004817/style1_desktop_center2.jpg'
                        }
                        alt={t('A_title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className="info">
                <h4 className="label">{t('A_label')}</h4>
                <h2 className="title">{t('A_title')}</h2>
                <div className="btns">
                    <EcoLink className="btn left" href="#D3U-P">
                        {t('A_left_btn')}
                    </EcoLink>
                    <EcoLink className="btn right" onClick={handlePlayYoutube}>
                        {t('A_right_btn')}
                        <svg className="info-btn-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM8.7926 13.7581L13.4382 10.4054C13.7147 10.2059 13.7147 9.79413 13.4382 9.59456L8.7926 6.24188C8.46192 6.00323 8 6.23952 8 6.64733V13.3527C8 13.7605 8.46192 13.9968 8.7926 13.7581Z"
                                fill="white"
                            />
                        </svg>
                    </EcoLink>
                </div>
            </div>

            <EFVideoModal visible={visible} source={youtube} onClose={() => setVisible(false)} playerType="YouTube" />
        </section>
    );
};

export default A;
